import React from 'react';

import { useLocation } from 'react-router-dom';

import { CurrencySelector } from '@pkg/components';
import { GlobalSearch } from '@pkg/components/GlobalSearch';
import { useAppSelector, useAuthentication } from '@pkg/hooks';

import { useBaseCurrencyStore } from '@app/store/zustand';

import { Icon } from '../SidebarNav/Icon';

import { CartButton, WalletButton } from './parts';

import {
    Background,
    LeftSide,
    LinkButton,
    LinkButtonIcon,
    LinkButtonLabel,
    RightSide,
    SearchWrapper,
    Wrapper,
} from './TopNav.style';

interface TopNavProps {
    bgImage?: string;
    hideBackground?: boolean;
    addButton?: React.ReactNode;
}

// TODO: Remove this once we are ready to use base currency.
const BETA_BASE_CURRENCY = false;

export const TopNav = ({ bgImage, hideBackground, addButton }: TopNavProps) => {
    const location = useLocation();
    const { handleAuthenticate } = useAuthentication();

    const currency = useBaseCurrencyStore((state) => state.currency);
    const setCurrency = useBaseCurrencyStore((state) => state.setCurrency);

    const enableCurrencySelector = useAppSelector((state) => state.featureFlags.features.enableCurrencySelector);
    const isVerifiedUser = useAppSelector((state) => state.user.isVerifiedUser);

    const isSearchPage = location.pathname.includes('/search');
    const isFantasyPage = location.pathname.includes('/fantasy') && location.pathname !== '/fantasy';

    const baseCurrencyMarkup =
        BETA_BASE_CURRENCY && enableCurrencySelector ? (
            <CurrencySelector glass selected={currency} onSelect={(currency) => setCurrency(currency)} />
        ) : null;

    if (isFantasyPage) return null;

    const walletAction = isVerifiedUser ? <WalletButton /> : null;

    const authAction = isVerifiedUser ? null : (
        <LinkButton onAction={handleAuthenticate}>
            <LinkButtonLabel>Sign up / Log in</LinkButtonLabel>
        </LinkButton>
    );

    return (
        <Wrapper>
            <Background $bgImage={bgImage} $hideBackground={hideBackground} $hideSearch={isSearchPage}>
                <LeftSide>
                    <SearchWrapper>{!isSearchPage && <GlobalSearch />}</SearchWrapper>
                </LeftSide>

                <RightSide>
                    {Boolean(addButton) && addButton}
                    {baseCurrencyMarkup}

                    {walletAction}

                    <LinkButton url="/create" state={{ state: { enableGoBack: true } }}>
                        <LinkButtonIcon>
                            <Icon name="plus" />
                        </LinkButtonIcon>
                        <LinkButtonLabel>Create Yats</LinkButtonLabel>
                    </LinkButton>

                    {authAction}

                    <CartButton />
                </RightSide>
            </Background>
        </Wrapper>
    );
};
